import {CommonModule} from "@angular/common";
import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import {RouterModule} from "@angular/router";
import {Store} from "@ngrx/store";
import {Subscription} from "rxjs";
import {AppbarConfig} from "../../config";
import {AppbarStateInterface} from "../../interfaces";
import {AppbarService} from "../../services";
import {selectIsLoggedIn} from "../../store/reducers/auth.reducer";
import {AppbarComponent} from "../appbar/appbar.component";
import {ToastsHostComponent} from "../toasts-host/toasts-host.component";

@Component({
  selector: "mtc-app-frame",
  templateUrl: "./app-frame.component.html",
  styleUrls: ["./app-frame.component.scss"],
  imports: [CommonModule, AppbarComponent, ToastsHostComponent, RouterModule]
})
export class AppFrameComponent implements OnInit, OnDestroy {
  private readonly appbarService = inject(AppbarService);
  private readonly store = inject(Store);

  protected appbarState: AppbarStateInterface;
  protected loggedIn$;

  private _subscriptions: Array<Subscription> = [];

  constructor() {
    this.appbarState = AppbarConfig;
    this.loggedIn$ = this.store.select(selectIsLoggedIn);
  }

  public ngOnInit(): void {
    this._subscriptions.push(this.appbarService.appStateObservable().subscribe(state => (this.appbarState = state)));
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }
}
